import imageCompression from 'browser-image-compression'

const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp']

export async function compressImage(file: File): Promise<File> {
  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new Error('Only JPEG, PNG, and WEBP images are supported.')
  }

  const compressed = await imageCompression(file, {
    maxSizeMB: 1,
    maxWidthOrHeight: 2048,
    useWebWorker: true,
  })

  return new File([compressed], file.name, { type: compressed.type })
}
